/*
 * Created Date: 16-01-2024, 10:20:57 am
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Tue Jan 30 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

export const WorkspaceDashboardRouterConfig = {
	auth: [],
	settings: {
		layout: {
			config: {
				sidebar: {
					display: true
				},
				header: {
					display: true
				},

				footer: {
					display: false
				}
			}
		}
	},
	routes: [
		{
			path: '/workspace/dashboard',
			element: <>123</>
		}
	]
}
